import { ACCENT } from "./constants";

export const createGetDayStyle = ({ highlightToday, dayStyle, isDark }) => {
  const today = new Date();

  return (date, modifiers) => {
    const customDayStyle =
      typeof dayStyle === "function" ? dayStyle(date, modifiers) : {};
    const isToday =
      highlightToday &&
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate();

    if (!isToday) {
      return customDayStyle;
    }

    const isSelectedDay = modifiers?.selected || modifiers?.selectedInRange;
    const todayHighlightStyle = {
      boxShadow: `inset 0 0 0 2px ${ACCENT}`,
      color: isDark ? "#F6F7F7" : "#1F2933",
    };

    return {
      ...customDayStyle,
      ...(!isSelectedDay ? todayHighlightStyle : {}),
      boxShadow: isSelectedDay
        ? "inset 0 0 0 2px #F6F7F7"
        : todayHighlightStyle.boxShadow,
      fontWeight: 700,
    };
  };
};
